import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Form, Label, Button } from 'semantic-ui-react';
import PhoneInput from './../PhoneInput';
import * as styles from './SignupForm.less';

const SignupStepTwo = props => {
  const {
    handleBlur,
    handleChange,
    values,
    errors,
    touched,
    nextStep,
    disabled,
  } = props;
  const firstName = errors.hasOwnProperty('firstName');
  const lastName = errors.hasOwnProperty('lastName');
  const disabled1 = firstName || lastName;
  return (
    <Fragment>
      <Form.Field>
        <label>4. First name</label>
      </Form.Field>
      <Form.Field className={styles.formField}>
        <Form.Input
          name='firstName'
          type='text'
          value={values.firstName || ''}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Form.Field>
      <Form.Field>
        {errors.firstName && touched.firstName && (
          <div className={styles.validationErrorWrapper}>
            <Label
              className={styles.validationError}
              color='red'
              basic
              pointing
            >
              {errors.firstName}
            </Label>
          </div>
        )}
      </Form.Field>
      <Form.Field>
        <label>5. Last name</label>
      </Form.Field>
      <Form.Field className={styles.formField}>
        <Form.Input
          name='lastName'
          type='text'
          value={values.lastName || ''}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Form.Field>
      <Form.Field>
        {errors.lastName && touched.lastName && (
          <div className={styles.validationErrorWrapper}>
            <Label
              className={styles.validationError}
              color='red'
              basic
              pointing
            >
              {errors.lastName}
            </Label>
          </div>
        )}
      </Form.Field>
      <Form.Field>
        <label>6. What's your phone number?</label>
      </Form.Field>
      <Form.Field className={styles.formField}>
        <PhoneInput {...props} />
      </Form.Field>
      <Form.Field>
        {errors.phone && touched.phone && (
          <div className={styles.validationErrorWrapper}>
            <Label
              className={styles.validationError}
              color='red'
              basic
              pointing
            >
              {errors.phone}
            </Label>
          </div>
        )}
      </Form.Field>
      <Form.Field>
        <Button
          onClick={nextStep}
          disabled={disabled1}
          className={styles.signUpButton}
        >
          Continue
        </Button>
      </Form.Field>
    </Fragment>
  );
};

export default SignupStepTwo;

SignupStepTwo.propTypes = {
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  dirty: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  setFieldValue: PropTypes.func,
  nextStep: PropTypes.func,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/views/components/SignupForm/SignupStepTwo.js